import { useContext } from "react";
import Footer from "./layouts/Footer";
import Nav from "./layouts/nav";
import { useSelector } from "react-redux";
import { ThemeContext } from "./context/ThemeContext";

const Layout = ({ children }) => {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""
        }`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height + 20 }}
      >
        <div className="container-fluid">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
